import {
  ReleasePlatformType,
  humanizeReleasePlatform,
} from '../../constants/releasePlatform';

export const getHumanizeReleasePlatform = (platform: ReleasePlatformType): string => {
  return humanizeReleasePlatform[platform] ?? platform;
};
